import { render, staticRenderFns } from "./gantt-number.vue?vue&type=template&id=2fb9cbac"
import script from "./gantt-number.vue?vue&type=script&lang=js"
export * from "./gantt-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports